import type { ReviewItem } from "../../../types/reviews";

const MALL_COLOR: Record<string, string> = { shopify: "var(--rv-shopify)", rakuten: "var(--rv-rakuten)" };
const MALL_LABEL: Record<string, string> = { shopify: "Shopify", rakuten: "楽天市場" };

const REPLY_STATUS_TAG: Record<string, { label: string; cls: string }> = {
  none: { label: "未返信", cls: "rv-tag--muted" },
  draft: { label: "下書き", cls: "rv-tag--warn" },
  queued: { label: "投稿待ち", cls: "rv-tag--info" },
  posted: { label: "返信済み", cls: "rv-tag--good" },
  failed: { label: "投稿失敗", cls: "rv-tag--bad" },
  skipped: { label: "スキップ", cls: "rv-tag--muted" },
};

const STAGE_LABEL: Record<string, string> = {
  cause: "原因分類待ち",
  resp: "個別対応待ち",
  improve: "再発防止待ち",
  ready: "完了確認待ち",
  done: "完了",
};

function stars(rating: number | null): string {
  if (rating === null) return "―";
  return "★".repeat(rating) + "☆".repeat(5 - rating);
}

function fmtDate(iso: string): string {
  return iso.slice(0, 16).replace("T", " ");
}

interface ReviewListPanelProps {
  items: ReviewItem[];
  selectedKey: string | null;
  onSelect: (key: string) => void;
}

export function ReviewListPanel({ items, selectedKey, onSelect }: ReviewListPanelProps) {
  if (items.length === 0) {
    return <div className="rv-empty">該当するレビューはありません。</div>;
  }
  return (
    <div className="rv-list">
      {items.map((item) => {
        const replyTag = REPLY_STATUS_TAG[item.reply.status];
        const doneSteps = item.flow ? ["cause", "resp", "improve", "ready", "done"].indexOf(item.flow.stage) + 1 : 0;
        return (
          <button
            key={item.key}
            className={`rv-list-item ${selectedKey === item.key ? "selected" : ""}`}
            style={{ borderLeftColor: MALL_COLOR[item.mall] }}
            onClick={() => onSelect(item.key)}
          >
            <div className="rv-list-item-head">
              <span className="rv-stars">{stars(item.rating)}</span>
              <span>{MALL_LABEL[item.mall]}</span>
              <span>{item.product ?? "ショップレビュー"}</span>
              <span className={`rv-tag ${replyTag.cls}`}>{replyTag.label}</span>
              {item.flow && <span className="rv-tag rv-tag--bad">{STAGE_LABEL[item.flow.stage]}</span>}
            </div>
            <div className="rv-list-item-body">{item.body}</div>
            {item.flow && (
              <div className="rv-progress-5">
                {[0, 1, 2, 3, 4].map((i) => (
                  <span key={i} className={i < doneSteps ? "done" : ""} />
                ))}
              </div>
            )}
            <div className={`rv-list-item-foot ${item.flow?.overdue ? "overdue" : ""}`}>
              <span>{fmtDate(item.postedAt)}</span>
              {item.flow ? (
                <span>
                  {item.flow.owner ?? "未割当"} ・{" "}
                  {item.flow.overdue
                    ? `期限超過（${Math.floor(item.flow.ageHours / 24)}日経過）`
                    : `個別対応期限まで あと${Math.max(0, Math.round(item.flow.ageHours))}h`}
                </span>
              ) : (
                <span>{item.orderNumber ?? ""}</span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
}
